import { render } from "./MarkenBoxen.vue?vue&type=template&id=74502223"
import script from "./MarkenBoxen.vue?vue&type=script&lang=ts"
export * from "./MarkenBoxen.vue?vue&type=script&lang=ts"

import "./MarkenBoxen.vue?vue&type=style&index=0&id=74502223&lang=scss"
script.render = render

export default script